import { identity } from '@sama/micro-dash';
import { Point3D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { CUBE_SIZE } from '../../../state/cuboid-location-state-3d';
import { CuboidFace } from './cuboid-helper';

// eslint-disable-next-line max-lines-per-function,complexity -- a cuboid has 6 faces, hence the 6 case statements
export function previewFaceOfInterest(face: CuboidFace): {
  position: Point3D;
  rotation: Point3D;
  getScale: (scale: Point3D) => Point3D;
} {
  switch (face) {
    case CuboidFace.Front:
      return {
        position: [0, -CUBE_SIZE / 2, -CUBE_SIZE / 2],
        rotation: [Math.PI / 2, 0, 0],
        getScale: (scale: Point3D) => [scale[0], scale[2], scale[1]],
      };
    case CuboidFace.Back:
      return {
        position: [0, CUBE_SIZE / 2, -CUBE_SIZE / 2],
        rotation: [Math.PI / 2, -Math.PI, 0],
        getScale: (scale: Point3D) => [scale[0], scale[2], scale[1]],
      };
    case CuboidFace.Right:
      return {
        position: [-CUBE_SIZE / 2, 0, -CUBE_SIZE / 2],
        rotation: [Math.PI / 2, -Math.PI / 2, 0],
        getScale: (scale: Point3D) => [scale[1], scale[2], scale[0]],
      };
    case CuboidFace.Left:
      return {
        position: [CUBE_SIZE / 2, 0, -CUBE_SIZE / 2],
        rotation: [Math.PI / 2, Math.PI / 2, 0],
        getScale: (scale: Point3D) => [scale[1], scale[2], scale[0]],
      };
    case CuboidFace.Top:
      return {
        position: [0, -CUBE_SIZE / 2, CUBE_SIZE / 2],
        rotation: [0, 0, 0],
        getScale: identity,
      };
    case CuboidFace.Bottom:
      return {
        position: [0, CUBE_SIZE / 2, -CUBE_SIZE / 2],
        rotation: [-Math.PI, 0, 0],
        getScale: identity,
      };
    default:
      return { position: [0, 0, 0], rotation: [0, 0, 0], getScale: identity };
  }
}
